import React, { useState, useEffect } from "react";
import Step1 from "./BusinessStep1";
import Step2 from "./BusinessStep2";
import Step3 from "./BusinessStep3";
import Success from "../components/Success";
import { useStep } from "react-hooks-helper";
import validate from "validate.js";

const steps = [
  { id: "business" },
  { id: "contact" },
  { id: "product" },
  { id: "success" },
];

export default function Business() {
  const { step, navigation } = useStep({ initialStep: 0, steps });
  const { id } = step;

  const [formState, setFormState] = useState({
    isValid: false,
    values: {},
    touched: {},
    errors: {},
  });

  useEffect(() => {
    const errors = validate(formState.values);
    setFormState((formState) => ({
      ...formState,
      isValid: errors ? false : true,
      errors: errors || {},
    }));
  }, [formState.values]);

  const newProps = { navigation, formState, setFormState };

  const renderSwitch = (id) => {
    switch (id) {
      case "business":
        return <Step1 {...newProps} />;
      case "contact":
        return <Step2 {...newProps} />;
      case "product":
        return <Step3 {...newProps} />;
      case "success":
        return <Success {...newProps} />;
      default:
        return null;
    }
  };

  const [value, setValue] = useState();

  return <>{renderSwitch(id)}</>;
}
